import React from 'react';
import { Modal } from './ui/Modal';
import { Button } from './ui/Button';

interface DeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName: string;
}

export const DeleteUserModal: React.FC<DeleteUserModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Confirmar Exclusão" size="md">
      <div className="space-y-4">
        <p className="text-sm text-dark-text-primary">
          Você tem certeza que deseja excluir o usuário{' '}
          <strong className="text-brand-lime">"{userName}"</strong>?
        </p>
        <p className="text-sm text-yellow-400">
          Esta ação não poderá ser desfeita.
        </p>
        <div className="flex justify-end space-x-3 pt-4 border-t border-dark-tertiary mt-2">
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={onConfirm}
          >
            Sim, Excluir Usuário
          </Button>
        </div>
      </div>
    </Modal>
  );
};